import React from 'react';
import { getEnv } from '../data/env';

export default function Img(props) {
    return (
        <img {...props} src={`${getEnv('PUBLIC_URL')}/assets/img/nf/${props.src}`} />
    );
}
